import React from 'react';
export function ProductMockup() {
  return <a href="#compra" className="block group cursor-pointer" data-id="element-218">
      <div className="relative w-full max-w-md mx-auto transform transition-transform duration-500 group-hover:scale-105" data-id="element-219">
        <img src="https://cdn.magicpatterns.com/uploads/ixeH6gCd4o4mP6ZQh6vzdg/heylloyd-image-1774647924328-removebg-preview.png" alt="Mega Pack Maestro Asador Argentino - 11 Tomos + 4 Bonos" className="w-full h-auto drop-shadow-[0_10px_40px_rgba(245,158,11,0.3)] group-hover:drop-shadow-[0_10px_50px_rgba(245,158,11,0.5)] transition-all duration-500" data-id="element-220" />
      </div>
    </a>;
}